module.exports = __webpack_public_path__ + "img/img_02.60c04f8c.png";